import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Chip,
  IconButton,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { deCryptFun } from "../comman/CustomFunction";
import { useFormik } from "formik";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { getAlluserList } from "../../redux/action";
import dayjs from "dayjs";
import * as types from "../../redux/action/ActionType";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const selectAdminBillingFilter = (state) => state.AdminBillingStatementFilter;

export default function AdminBillingStatementFilter(props) {
  const {
    open,
    handleClose,
    filter,
    setFilter,
    filterInitial,
    setApplyFilterFlag,
    submitFilter,
    billPeriod,
  } = props;
  const reduxFilter = useSelector(selectAdminBillingFilter);
  console.log(reduxFilter, "reduxxxxxxxxxxxxxxxxx");
  const dispatch = useDispatch();
  const userListSel = deCryptFun(useSelector((s) => s.AllUserReducer));
  const list = userListSel
    ? JSON.parse(userListSel).data.filter(
        (userlist) =>
          userlist.UserRole &&
          userlist.UserRole.split(",").includes(
            "6d8f5f3c-8ed1-40d5-b870-d54283c7da28"
          )
      )
    : [];
  console.log(list, "lidatatatataaatat");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [tempFilter, setTempFilter] = useState(filter);
  console.log(tempFilter, "tempFiltertempFilter");
  useEffect(() => {
    setTempFilter(filter);
    // setDateErrors({ startDate: "", endDate: "" });
  }, [filter]);

  const handleChangeBillingEndDate = (val) => {
    const formattedDate = dayjs(val).format("YYYY-MM-DD");
    setTempFilter({
      ...tempFilter,
      billingEndDate: formattedDate,
      billingEndDateDatepicker: val,
    });
  };

  const handleChangeBillingStartDate = (val) => {
    const formattedDate = dayjs(val).format("YYYY-MM-DD");
    setTempFilter({
      ...tempFilter,
      billingStartDate: formattedDate,
      billingStartDateDatepicker: val,
    });
  };

  const handleChangeCustomer = (event) => {
    console.log(event, "eveneneenen");
    const {
      target: { value },
    } = event;
    setTempFilter({ ...tempFilter, broker: value });
  };

  const resetFun = () => {
    setTempFilter(filterInitial);
    // setDateErrors({ startDate: "", endDate: "" });
    // setValues(filterInitial);
  };

  const validateDates = (values) => {
    let errors = {};
    const start = values.billingStartDateDatepicker
      ? dayjs(values.billingStartDateDatepicker)
      : null;
    const end = values.billingEndDateDatepicker
      ? dayjs(values.billingEndDateDatepicker)
      : null;

    if (!start && end) {
      errors.billingStartDate = "Start date is required.";
    } else if (start && !start.isValid()) {
      errors.billingStartDate = "Invalid date";
    }

    if (!end && start) {
      errors.billingEndDate = "End date is required.";
    } else if (end && !end.isValid()) {
      errors.billingEndDate = "Invalid date";
    }

    if (
      start &&
      end &&
      start.isValid() &&
      end.isValid() &&
      !start.isBefore(end) &&
      !start.isSame(end)
    ) {
      errors.billingStartDate =
        "The 'From' date must be before or equal to the 'To' date.";
      errors.billingEndDate =
        "The 'To' date must be after or equal to the 'From' date.";
    }

    return errors;
  };
  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
    validateForm,
  } = useFormik({
    initialValues: tempFilter,
    enableReinitialize: true,
    validate: validateDates,
    onSubmit: (values) => {
      validateForm().then((errors) => {
        if (!Object.keys(errors).length) {
          setApplyFilterFlag(true);
          setFilter(tempFilter);
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: { filterValues: tempFilter },
          });
          submitFilter();
          handleClose();
        }
      });
    },
  });
  console.log(errors, "eroorreeee");
  const clearProject = () => {
    setTempFilter({ ...tempFilter, broker: [] });
  };

  useEffect(() => {
    dispatch(getAlluserList());
    setTempFilter(reduxFilter?.filterValues);
  }, []);

  const handleSearchDeleteOnChange = (customerId) => {
    console.log(customerId, "customerIsdddddd");
    // Filter out the broker that is being deleted
    const updatedBrokers = tempFilter.broker.filter((id) => id !== customerId);

    // Update the tempFilter state with the new broker list
    setTempFilter({ ...tempFilter, broker: updatedBrokers });
  };

  return (
    <>
      <Dialog
        className="user-filter-popup cst-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            // className="reset-disable"
            variant="outlined"
            startIcon={<span class="material-symbols-outlined">history</span>}
            onClick={resetFun}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          {/* <p style={{ mb: "0px" }} className="label oh-label">
            Selected Project has {billPeriod} days Billing Period
          </p> */}

          <Stack direction="row" alignItems="baseline" spacing={4}>
            <FormControl
              sx={{ width: "100%", mb: "10px !important" }}
              variant="standard"
              error={!!(touched.billingStartDateDatepicker && errors.startDate)}
            >
              <p style={{ mb: "0px" }} className="label">
                Billing Period Start Date:
              </p>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DemoContainer components={["DatePicker"]}> */}
                <DatePicker
                  className="filter-biiling-date"
                  sx={{
                    minWidth: { xs: "auto !important", sm: "auto" },
                    "&.cst-filter": {
                      marginBottom: "0px !important",
                    },
                  }}
                  name="billingStartDateDatepicker"
                  id="billingStartDateDatepicker"
                  value={tempFilter?.billingStartDateDatepicker || null}
                  // value={
                  //   filter.billingStartDateDatepicker
                  //     ? filter.billingStartDateDatepicker
                  //     : null
                  // }
                  onChange={(dateValue) =>
                    handleChangeBillingStartDate(dateValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        ".MuiInputBase-root": {
                          borderColor:
                            touched.billingStartDateDatepicker &&
                            errors.startDate
                              ? "red"
                              : tempFilter?.billingEndDateDatepicker &&
                                params?.inputProps?.disabled
                              ? "yellow"
                              : "",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor:
                              touched.billingStartDateDatepicker &&
                              errors.startDate
                                ? "red"
                                : tempFilter?.billingEndDateDatepicker &&
                                  params?.inputProps?.disabled
                                ? "yellow"
                                : "",
                          },
                        },
                        ".MuiInputBase-root.Mui-error": {
                          borderColor: "red",
                        },
                      }}
                    />
                  )}
                  allowClear
                  shouldDisableDate={(date) =>
                    tempFilter?.billingEndDateDatepicker &&
                    date.isAfter(tempFilter.billingEndDateDatepicker, "day")
                  }
                />
                {/* </DemoContainer> */}
              </LocalizationProvider>
              {touched.billingStartDate && errors.billingStartDate && (
                <FormHelperText error={true}>
                  {errors.billingStartDate}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl
              sx={{ width: "100%", mb: "10px !important" }}
              variant="standard"
              error={!!(touched.billingEndDateDatepicker && errors.endDate)}
            >
              <p style={{ mb: "0px" }} className="label">
                Billing Period End Date:
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {/* <DemoContainer components={["DatePicker"]}> */}
                <DatePicker
                  className="filter-biiling-date"
                  sx={{ minWidth: { xs: "auto !important", sm: "auto" } }}
                  name="billingEndDate"
                  id="billingEndDate"
                  // inputFormat="DD-MM-YYYY"
                  value={tempFilter?.billingEndDateDatepicker || null}
                  // value={
                  //   filter.billingEndDateDatepicker
                  //     ? filter.billingEndDateDatepicker
                  //     : null
                  // }
                  onChange={(dateValue) =>
                    handleChangeBillingEndDate(dateValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        ".MuiInputBase-root": {
                          outline:
                            touched.billingEndDateDatepicker && errors.endDate
                              ? "red"
                              : tempFilter?.billingStartDateDatepicker &&
                                params?.inputProps?.disabled
                              ? "yellow"
                              : "",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            outline:
                              touched.billingEndDateDatepicker && errors.endDate
                                ? "red"
                                : tempFilter?.billingStartDateDatepicker &&
                                  params?.inputProps?.disabled
                                ? "yellow"
                                : "",
                          },
                        },
                        ".MuiInputBase-root.Mui-error": {
                          outline: "red",
                        },
                      }}
                    />
                  )}
                  allowClear
                  shouldDisableDate={(date) =>
                    tempFilter?.billingStartDateDatepicker &&
                    date.isBefore(tempFilter.billingStartDateDatepicker, "day")
                  }
                />
                {/* </DemoContainer> */}
              </LocalizationProvider>
              {touched.billingEndDate && errors.billingEndDate && (
                <FormHelperText error={true}>
                  {errors.billingEndDate}
                </FormHelperText>
              )}
            </FormControl>
          </Stack>
          {/* <Stack direction="row" alignItems="center" spacing={2}>
            <FormControl
              className="search-box filter-searchbox"
              sx={{ m: 1, maxWidth: "357px" }}
            >
              <p className="label">Select Broker:</p>
              <Autocomplete
                multiple
                id="broker-select"
                options={list || []}
                getOptionLabel={(option) =>
                  `${option?.FirstName} ${option?.LastName}`
                }
                value={tempFilter?.broker || []}
                onChange={(_, newValue) => handleChangeCustomer(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Search and select broker"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {tempFilter?.broker?.length > 0 && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                aria-label="clear"
                                onClick={clearProject}
                              >
                                <HighlightOffIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.UserId}
                      label={`${option.FirstName} ${option.LastName}`}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                getOptionSelected={(option, value) =>
                  option.UserId === value.UserId
                }
              />
            </FormControl>
          </Stack> */}
          <Stack
            sx={{ mt: "13px" }}
            direction="row"
            alignItems="center"
            spacing={4}
          >
            <FormControl
              className="search-box filter-searchbox"
              sx={{ m: 1, maxWidth: "357px" }}
            >
              <p className="label">Select Broker:</p>
              <Select
                sx={{
                  pr: "0px",
                  ".MuiSelect-select": {
                    color:
                      Array.isArray(tempFilter?.broker) &&
                      tempFilter?.broker.length === 0
                        ? "#898989 !important"
                        : "#212121 !important",
                  },
                  minWidth: tempFilter?.broker?.length > 0 ? "0px" : "100%",
                  paddingRight: tempFilter?.broker?.length > 0 ? "14px" : "0px",
                }}
                labelId="demo-multiple-chip-label"
                placeholder="Select Broker"
                id="demo-multiple-chip"
                displayEmpty
                multiple
                IconComponent={KeyboardArrowDownIcon}
                value={
                  Array.isArray(tempFilter?.broker) ? tempFilter.broker : []
                }
                onChange={handleChangeCustomer}
                input={<OutlinedInput id="select-multiple-chip" />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Select Broker"; // This will show the placeholder
                  }

                  return (
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {selected.map((customerId) => {
                        const customer = list.find(
                          (c) => c.UserId === customerId
                        );

                        return (
                          <Chip
                            key={customerId}
                            label={
                              customer
                                ? `${customer.FirstName} ${customer.LastName}`
                                : "Unknown"
                            }
                            style={{ margin: 5 }}
                          />
                        );
                      })}
                    </div>
                  );
                }}
                MenuProps={MenuProps}
                endAdornment={
                  <InputAdornment position="start">
                    {tempFilter?.broker && tempFilter?.broker?.length > 0 ? (
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={clearProject}
                      >
                        <HighlightOffIcon fontSize="small" />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </InputAdornment>
                }
              >
                <MenuItem disabled value="">
                  Select Broker
                </MenuItem>
                {list &&
                  list.map((value) => (
                    <MenuItem key={value.UserId} value={value.UserId}>
                      <Checkbox
                        checked={
                          Array.isArray(tempFilter?.broker) &&
                          tempFilter.broker.indexOf(value?.UserId) > -1
                        }
                      />
                      <ListItemText
                        primary={`${value?.FirstName} ${value.LastName}`}
                      />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "26px 34px", pt: "15px" }}
        >
          <Button
            className="filter-btn"
            type="submit"
            // disabled={
            //   tempFilter.billingEndDate == "" &&
            //   tempFilter.billingStartDate == "" &&
            //   tempFilter.broker == ""
            // }
          >
            Apply Filter
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
